var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TablePaginatedToggleButton',{attrs:{"label":"Advertisement","main-list":_vm.itemData,"is-global-percent":_vm.isGlobalPercent,"visible-pages-numbers":5,"is-has-tabs":"","is-show-total-label":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }